// Single source of truth for DueMate registered business information.
// These details appear on public pages, footer, legal pages, and JSON-LD
// so Meta / Google / other verifiers can machine-read the same values.
//
// Update this file if the underlying registration changes.

export const BUSINESS = {
  legalName: "DueMate",
  ownerName: "Lakhit Almeida",
  organizationType: "Proprietorship",
  udyamNumber: "UDYAM-GA-02-0041088",
  address: {
    line1: "H269/E",
    locality: "Cansaulim",
    region: "Goa",
    postalCode: "403712",
    country: "IN",
    countryName: "India",
    formatted: "H269/E, Cansaulim, Goa 403712, India",
  },
  phone: "+919819009485",
  phoneDisplay: "+91 98190 09485",
  email: "support@duemateapp.com",
  website: "https://duemateapp.com",
  founded: "2026-07-31",
  foundedDisplay: "July 2026",
  activity: "Computer programming, consultancy and related activities — SaaS platform for customer service reminders and payment collection.",
};

// JSON-LD structured data for Organization + LocalBusiness.
// Search / verification crawlers use this to confirm business identity.
export function organizationJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": ["Organization", "LocalBusiness"],
    name: BUSINESS.legalName,
    legalName: BUSINESS.legalName,
    url: BUSINESS.website,
    email: BUSINESS.email,
    telephone: BUSINESS.phone,
    founder: { "@type": "Person", name: BUSINESS.ownerName },
    foundingDate: BUSINESS.founded,
    description: BUSINESS.activity,
    identifier: {
      "@type": "PropertyValue",
      propertyID: "Udyam Registration Number",
      value: BUSINESS.udyamNumber,
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: `${BUSINESS.address.line1}, ${BUSINESS.address.locality}`,
      addressLocality: BUSINESS.address.locality,
      addressRegion: BUSINESS.address.region,
      postalCode: BUSINESS.address.postalCode,
      addressCountry: BUSINESS.address.country,
    },
    contactPoint: [{
      "@type": "ContactPoint",
      contactType: "customer support",
      email: BUSINESS.email,
      telephone: BUSINESS.phone,
      areaServed: "IN",
      availableLanguage: ["English", "Hindi"],
    }],
  };
}
